module.exports = __webpack_public_path__ + "static/fill-forms-2683516a13e28968555eacc6b338bc2f.png";